import loadable from '@loadable/component';
export const manifest = {
  CpasShowcase: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CpasShowcase";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CpasShowcase" */
          '.'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak(".");
            }

            return eval('require.resolve')(".");
          }

        }, {
          resolveComponent: m => m.CpasShowcase
        })
      }
    }
  },
  'CpasShowcase.IconView': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CpasIconViewDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CpasIconViewDesktop" */
          './src/widgets/cpas-icon-view/desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/cpas-icon-view/desktop");
            }

            return eval('require.resolve')("./src/widgets/cpas-icon-view/desktop");
          }

        }, {
          resolveComponent: m => m.CpasIconViewDesktop
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CpasIconViewMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CpasIconViewMobile" */
          './src/widgets/cpas-icon-view/mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/cpas-icon-view/mobile");
            }

            return eval('require.resolve')("./src/widgets/cpas-icon-view/mobile");
          }

        }, {
          resolveComponent: m => m.CpasIconViewMobile
        })
      }
    }
  },
  'CpasShowcase.Badge': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CpasBadge";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CpasBadge" */
          './src/widgets/cpas-badge'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/cpas-badge");
            }

            return eval('require.resolve')("./src/widgets/cpas-badge");
          }

        }, {
          resolveComponent: m => m.CpasBadge
        })
      }
    }
  },
  'CpasShowcase.Layout': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CpasShowcaseLayout";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CpasShowcaseLayout" */
          './src/widgets/cpas-layout'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/cpas-layout");
            }

            return eval('require.resolve')("./src/widgets/cpas-layout");
          }

        }, {
          resolveComponent: m => m.CpasShowcaseLayout
        })
      }
    }
  }
};